(() => {
  const enhanceProductDetails = (root = document) => {
    root.querySelectorAll('.product-details h5').forEach((heading) => {
      const text = heading.textContent?.replace(/\s+/g, ' ').trim().toLowerCase() || '';
      if (!text.startsWith('lieferzeit')) return;

      const wrapper = heading.parentElement;
      if (!wrapper || wrapper.classList.contains('aks-delivery-row')) return;
      wrapper.classList.add('aks-delivery-row');
    });
  };

  const start = () => enhanceProductDetails(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceProductDetails(event.target));
})();
